import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@repo/app-router';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@repo/ui-primitives';
import { useMemo } from 'react';
function convertToModulesRowData(organization, project, appVersion, applicationName) {
    if (!appVersion || !applicationName) {
        return [];
    }
    const { overrides = [], modules = [] } = appVersion;
    const findVersion = (name)=>{
        const override = overrides.find((param)=>{
            let { name: ovName } = param;
            return ovName === name;
        });
        return override ? " (".concat(override.version, ")") : '';
    };
    return modules.map((module)=>({
            name: module.name,
            file: module.file,
            requires: module.requires.map((name)=>"".concat(name).concat(findVersion(name))),
            applicationName,
            moduleUrl: "/org/".concat(organization, "/").concat(project, "/").concat(applicationName, "/module/").concat(module.name, "/")
        }));
}
function convertToConsumesRowData(organization, project, consumes) {
    if (!consumes) {
        return [];
    }
    return consumes.map((param)=>{
        let { name, applicationID, usedIn } = param;
        return {
            name,
            application: applicationID,
            file: usedIn ? usedIn.map((param)=>{
                let { file, url } = param;
                return {
                    name: file,
                    url
                };
            }) : [],
            moduleUrl: "/org/".concat(organization, "/").concat(project, "/").concat(applicationID, "/module/").concat(name, "/")
        };
    });
}
export function RemoteModules(param) {
    let { organization, project, application, appVersion, emptyExposedText, emptyConsumedText } = param;
    const modulesRowData = useMemo(()=>convertToModulesRowData(organization !== null && organization !== void 0 ? organization : '', project !== null && project !== void 0 ? project : '', appVersion, application), [
        organization,
        project,
        appVersion,
        application
    ]);
    const consumesRowData = useMemo(()=>convertToConsumesRowData(organization !== null && organization !== void 0 ? organization : '', project !== null && project !== void 0 ? project : '', appVersion === null || appVersion === void 0 ? void 0 : appVersion.consumes), [
        organization,
        project,
        appVersion === null || appVersion === void 0 ? void 0 : appVersion.consumes
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-8 w-full min-w-0",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-4 w-full min-w-0",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "text-lg font-semibold",
                        children: "Exposed Modules"
                    }),
                    modulesRowData.length === 0 ? /*#__PURE__*/ _jsx("div", {
                        className: "flex flex-col items-center justify-center gap-2 py-12 text-muted-foreground",
                        children: emptyExposedText || /*#__PURE__*/ _jsx("p", {
                            children: "No data found"
                        })
                    }) : /*#__PURE__*/ _jsxs(Table, {
                        children: [
                            /*#__PURE__*/ _jsx(TableHeader, {
                                children: /*#__PURE__*/ _jsxs(TableRow, {
                                    children: [
                                        /*#__PURE__*/ _jsx(TableHead, {
                                            children: "Name"
                                        }),
                                        /*#__PURE__*/ _jsx(TableHead, {
                                            children: "File"
                                        }),
                                        /*#__PURE__*/ _jsx(TableHead, {
                                            children: "Requires"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(TableBody, {
                                children: modulesRowData.map((row, index)=>/*#__PURE__*/ _jsxs(TableRow, {
                                        children: [
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    to: row.moduleUrl,
                                                    children: row.name
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                children: row.file
                                            }),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                children: row.requires.map((val, idx)=>/*#__PURE__*/ _jsxs("span", {
                                                        children: [
                                                            val,
                                                            idx === row.requires.length - 1 ? '' : ', '
                                                        ]
                                                    }, "require_row_".concat(index, "_").concat(idx)))
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-4 w-full min-w-0",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "text-lg font-semibold",
                        children: "Consumes"
                    }),
                    consumesRowData.length === 0 ? /*#__PURE__*/ _jsx("div", {
                        className: "flex flex-col items-center justify-center gap-2 py-12 text-muted-foreground",
                        children: emptyConsumedText || /*#__PURE__*/ _jsx("p", {
                            children: "No data found"
                        })
                    }) : /*#__PURE__*/ _jsxs(Table, {
                        children: [
                            /*#__PURE__*/ _jsx(TableHeader, {
                                children: /*#__PURE__*/ _jsxs(TableRow, {
                                    children: [
                                        /*#__PURE__*/ _jsx(TableHead, {
                                            children: "Name"
                                        }),
                                        /*#__PURE__*/ _jsx(TableHead, {
                                            children: "Used In"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(TableBody, {
                                children: consumesRowData.map((row, index)=>{
                                    var _row_file_, _row_file_1;
                                    return /*#__PURE__*/ _jsxs(TableRow, {
                                        children: [
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    to: row.moduleUrl,
                                                    children: "".concat(row.application, "/").concat(row.name)
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                children: row.file.length > 0 ? /*#__PURE__*/ _jsx(Link, {
                                                    to: (_row_file_ = row.file[0]) === null || _row_file_ === void 0 ? void 0 : _row_file_.url,
                                                    children: (_row_file_1 = row.file[0]) === null || _row_file_1 === void 0 ? void 0 : _row_file_1.url
                                                }) : null
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
